
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_ndv9i_9",
  "root-horizontal": "awsui_root-horizontal_o08jm_ndv9i_43",
  "root-vertical": "awsui_root-vertical_o08jm_ndv9i_48",
  "control": "awsui_control_o08jm_ndv9i_53",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_ndv9i_60",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_ndv9i_60",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_ndv9i_63",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_ndv9i_63",
  "ghost": "awsui_ghost_o08jm_ndv9i_67"
};
  